import { createContext, useContext } from "react";
import { Socket } from "socket.io-client";
import { useSocketEvents } from "./use-socket-events";

type SocketContextType = {
  socket: Socket | null;
};

export const SocketContext = createContext<SocketContextType | null>(null);

type SocketProviderProps = {
  children: React.ReactNode;
  currentPage:
    | "route-planner"
    | "region-management"
    | "customer-management"
    | "notifications"
    | "snow-reports";
  routePlannerDate?: string;
};

const SocketContextProvider = ({
  children,
  currentPage,
  routePlannerDate,
}: SocketProviderProps) => {
  const { socket } = useSocketEvents({
    currentPage,
    routePlannerDate,
  });

  return (
    <SocketContext.Provider value={{ socket }}>
      {children}
    </SocketContext.Provider>
  );
};

export default SocketContextProvider;

export const useSocketContext = (): SocketContextType => {
  const context = useContext(SocketContext);
  if (!context) {
    throw new Error("useSocketContext must be used within a SocketProvider");
  }
  return context;
};
